export default __webpack_public_path__ + "static/media/expand.f338a800.svg";